import { RouterProvider } from "react-router-dom";
import router from "./utils/router";
import useLoaderContext, { Loader } from "./hooks/useLoading";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ContextProvider } from "./contextProvider/contentTypeProvider";

const App = () => {
  const { loading } = useLoaderContext();
  return (
    <ContextProvider>
      <div className="App">
        {loading ? <Loader /> : null}
        <RouterProvider router={router} />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </ContextProvider>
  );
};
export default App;
